import React, { Component, ReactNode } from "react";
import ErrorRenderer from "./ErrorRenderer";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: {
    message: string;
    stack: string;
  };
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: undefined,
    } as ErrorBoundaryState;
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      error: {
        message: error.message,
        stack: errorInfo.componentStack,
      },
    } as any);
  }

  render(): React.ReactNode {
    if (this.state.hasError && this.state.error) {
      return <ErrorRenderer error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
